import { RouteObjectRule } from "../router";
import { lazy, ReactNode, Suspense } from "react";
import { LuckLoading, LuckProgress } from '../../components/Luck';

export const lazyLoad = (children: ReactNode): ReactNode => {
	return (
		<Suspense fallback={
			<LuckProgress><LuckLoading /></LuckProgress>
		}>
			{children}
		</Suspense>
	)
}
const TeacherIndex = lazy(() => import('../../pages/Qzwd/Teacher'))
const TeacherAdd = lazy(() => import('../../pages/Qzwd/Teacher/add'))
const TeacherEdit = lazy(() => import('../../pages/Qzwd/Teacher/edit'))

const CategoryIndex = lazy(() => import('../../pages/Qzwd/Category'))

const Article = lazy(() => import('../../pages/Qzwd/Article'))
const ArticleAdd = lazy(() => import('../../pages/Qzwd/Article/add'))
const ArticleEdit = lazy(() => import('../../pages/Qzwd/Article/edit'))
const Config = lazy(() => import('../../pages/Qzwd/Config'))

const MisRouter: RouteObjectRule[] = [
	{
		path: "/qzwd",
		children: [
			{
				path: "/qzwd/teacher",
				element: lazyLoad(<TeacherIndex />)
			},
			{
				path: "/qzwd/teacher/add",
				element: lazyLoad(<TeacherAdd />)
			},
			{
				path: "/qzwd/teacher/edit/:id",
				element: lazyLoad(<TeacherEdit />)
			},

			{
				path: "/qzwd/category",
				element: lazyLoad(<CategoryIndex />)
			},

			{
				element: lazyLoad(<Article />),
				path: '/qzwd/article',
			},
			{
				path: "/qzwd/article/add",
				element: lazyLoad(<ArticleAdd />)
			},
			{
				path: "/qzwd/article/edit/:id",
				element: lazyLoad(<ArticleEdit />)
			},
			{
				path: "/qzwd/config",
				element: lazyLoad(<Config />)
			},
		]
	}
];

export default MisRouter;